var render = function render(_c,_vm){return _c('div',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$options.show(_vm.props)}}},[_vm._v(_vm._s(_vm.props.row.nombre))])])
}
var staticRenderFns = []

export { render, staticRenderFns }